  /* Where the visitor was when they chose to sign in. The OIDC round-trip lands
    on /auth/callback, so without this every sign-in would end at the home page.
    Session-scoped: it describes one trip through the browser, not a preference. */
const KEY = 'lux-auth-resume'

const remember = () => {
  sessionStorage.setItem(KEY, window.location.pathname + window.location.search)
}

const resume = (): string => {
  const to = sessionStorage.getItem(KEY)
  sessionStorage.removeItem(KEY)
  return to ?? '/'
}

export { remember, resume }
